import { Component, OnInit } from '@angular/core';
import { BroadcastService, MsalService } from '@azure/msal-angular';
import { BaseAutorizeComponent } from '../shared/base-authorize.component';
import { AzureFunctionsService, Status, Subscription, IProcess, IProcessModel } from 'src/app/azurefunctions/azure-functions.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent extends BaseAutorizeComponent{

  processes: IProcessModel[] = [];
  working: boolean = true;
  userName: string;
  constructor(broadcastService: BroadcastService, authService: MsalService, private functionsService: AzureFunctionsService) { 
    super(broadcastService, authService)
  }

  onInitChild(){
    if(this.loggedIn){
      this.userName = this.authService.getAccount().name;
    }

    this.functionsService.availableProcesses().then((p)=> {
      this.working = false;
        this.processes = p;
    },(er) => {
      this.working = false;
    });
  }

  // ngOnInit(){
  //   this.functionsService.availableProcesses().then((p)=> {
  //     console.log(p);
  //   });
  // }
 
}

